import { Center, Skeleton } from '@chakra-ui/react';
import CustomDataTableEditBtn from '@Modules/core/components/table/CustomDataTableEditBtn';
import { createColumnHelper } from '@tanstack/react-table';

export type TCommonReasonDataTableData = {
  primaryKey: string | number,
  id: string,
  name: string,
  [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
  columnNames?: string[],
};

const columnHelper = createColumnHelper<TCommonReasonDataTableData>();

export function getCommonReasonDataTableColumns({
  isLoading,
  handleEdit, columnNames
}: Props) {
  return [
    columnHelper.accessor('id', {
      id: 'id',
      header: (columnNames && columnNames.length >= 1 && columnNames[0]) || 'ID',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
        <>{props.getValue()}</>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('name', {
      id: 'name',
      header: (columnNames && columnNames.length >= 2 && columnNames[1]) || 'Nom',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
              <CustomDataTableEditBtn onClick={() => handleEdit(props.row)} />
          </Skeleton>
        );
      },
    }),
  ];
}
